import { createFileRoute } from '@tanstack/react-router';
import { S8Reports } from '@/screens/S8Reports/S8Reports';
import { useApiClients } from '@/app/ApiProvider';

export const Route = createFileRoute('/$orgId/reports')({
  component: ReportsScreen,
});

function ReportsScreen() {
  const clients = useApiClients();
  return <S8Reports clients={clients} />;
}
